<div class="row">
  <div class="col-sm-12 col-md-12">
    <form [formGroup]="_mFormGroup">
      <div class="d-flex customShift-pickupFlexBox" style="align-items: flex-end;">
        <div>
          <label>Location<sup class="mandatory">*</sup></label>
          <select class="form-select" placeholder="City" formControlName="city" (change)="getSitesByCityId($event)">
            <option disabled value="">Choose Location</option>
            <option *ngFor="let city of cities" [value]="city.locationId">
              {{ city.locationName }}
            </option>
          </select>

        </div>
        <div>
          <label>Site<sup class="mandatory">*</sup></label>
          <select class="form-select" placeholder="Select Site" [disabled]="(this.mCity.value) ?
            false : true" formControlName="site" (change)="onsitechange($event)">
            <option disabled value="">Choose Site</option>
            <option *ngFor="let site of sites" [value]="site.siteId">
              {{ site.siteName}}
            </option>
          </select>
        </div>

        <div>
          <label>Filter Type<sup class="mandatory">*</sup></label>
          <select class="form-select" placeholder="Filter Type" formControlName="filterType"
            (change)="showFlag = false">
            <option disabled value="">Choose Filter Type</option>
            <option *ngFor="let shown of showBy" [value]="shown.type">
              {{shown.name }}
            </option>
          </select>
        </div>
        <div class="col-12 mt-5 d-flex justify-content-end gap-2">
          <button class="btn playlist-btn-solid" [disabled]="!(mCity.value && mSite.value && mFilterType.value)"
            (click)="showMapping(mFilterType.value)">
            Show Mapping
          </button>

          <img src="./assets/images/excel.svg" *ngIf="shiftmapping.length > 0" (click)="exportAsXLSX()"
            matTooltip="Export To Excel" style="cursor: pointer;">

          <button *ngIf="showFlag" class="btn playlist-btn-solid" (click)="saveMapping()">
            Save Mapping
          </button>
        </div>

      </div>
    </form>
  </div>
</div>


<div *ngIf="showMappings" class="row mt-4">
  <div class="shiftpickup">
    <div class="shiftpickup-top" *ngIf="rows.length > 0">
      <mat-checkbox class="shift-pickup-check-box" [checked]="isAllChecked()"
        (change)="checkAll($event)"></mat-checkbox><span
        style="font-size: 14px; font-weight: 500; font-family: 'poppins' !important;">Select
        All</span>
    </div>
    <span class="items mat-color--white tdw-border-2
          tdw-font-14" *ngFor="let row of rows">
      <mat-checkbox class="shift-pickup-check-box" [(ngModel)]="row.state"
        (change)="onValueChecked($event,row)"></mat-checkbox>
      <span style="font-size: 13px; font-weight: 400; font-family: 'poppins' !important;">{{row.value}}</span>
    </span>
  </div>
  <div class="shiftpickup">
    <div class="shiftpickup-top" *ngIf="unPushedValues.length > 0">
      <mat-checkbox class="shift-pickup-check-box" [checked]="!isAllChecked() || isAllChecked()"
        (change)="unCheckAll($event)"></mat-checkbox> <span
        style="font-size: 14px; font-weight: 500; font-family: 'poppins' !important;">UnSelect
        All</span>
    </div>
    <span class="items mat-color--white tdw-border-2
          tdw-font-14" *ngFor="let row of unPushedValues">
      <mat-checkbox class="shift-pickup-check-box" [(ngModel)]="row.state"
        (change)="onSelValueChecked($event,row)"></mat-checkbox>
      <span style="font-size: 13px; font-weight: 400; font-family: 'poppins' !important;">{{row.value}}</span>
    </span>
  </div>
</div>

<div class="row mt-3" *ngIf="shiftmapping.length > 0">
  <div class="col-sm-12 col-md-12">
    <table class="shiftpickup-pointTable mt-3">
      <tr style="border-bottom: 1px solid #EFF2F7 !important; background: #ffffff !important;">
        <th>Location</th>
        <th>Site Name</th>
        <th>Shift Time</th>
        <th>Pick/Drop Type</th>
      </tr>
      <tr *ngFor="let data of shiftmapping">
        <td>{{data.site.location.locationName}}</td>
        <td>{{data.site.siteName}}</td>
        <td>{{data.shift.shiftTime}} {{data.shift.logType}}</td>
        <td>{{data.type== "C" ? "COMMON POINT" : "HOME POINT"}}</td>
      </tr>
    </table>
  </div>
</div>